import { useTranslation } from 'react-i18next';
import React, {useState} from 'react';
import ectoollogo from '../../assets/images/ectool_Logo_2019.png';
import apiRequest from '../../functions/api';
import { Box, TextField, Card, CardContent, Typography, Button, Grid} from "@mui/material";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useMessage } from '../../context/message-context';
import {useSessionStorage} from '../../utils/hooks';
import {LOCAL_STORAGE_KEY} from '../../constants/localStorage';
function NewPassword() {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword , setNewPassword] = useState('');
  const [confirmPassword , setConfirmPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [accessToken, ] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const {showErrorMessage, showSuccessMessage} = useMessage();
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
        
  const newPasswordCb = (response) => {
    if (response.status === 200) {
      showSuccessMessage(t("Freischaltung erfolgreich."));
      window.location.reload();
    } else {
      if (response) {
        setNewPasswordError(response.data.message);
      } else {
        showErrorMessage(t("Netzwerkfehler. Sind Sie mit dem Internet verbunden?"));
      }
    }
  }
  function validatePassword() {
    var errors = [];
    if (newPassword.length < 8) {
        errors.push("Ihr Passwort muss mindestens 8 Zeichen enthalten");
    }
    if (newPassword.search(/[a-z]/) < 0) {
        errors.push("Ihr Passwort muss mindestens einen Kleinbuchstaben enthalten"); 
    }
    if (newPassword.search(/[A-Z]/) < 0) {
      errors.push("Ihr Passwort muss mindestens einen Großbuchstaben enthalten"); 
  }
  if (newPassword.search(/[0-9]/) < 0) {
        errors.push("Ihr Passwort muss mindestens eine Ziffer enthalten");
    }
    if (newPassword.search(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/) < 0) {
      errors.push("Ihr Passwort muss mindestens ein Sonderzeichen enthalten");
    }
    if (errors.length > 0) {
        setNewPasswordError(errors.join("\n"));
        return false;
    } else {
      setNewPasswordError(null);
    }
    return true;
  }
        
  const handlePasswordChangeClick = (e) => {
    e.preventDefault();
    if (!validatePassword()) return
    if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Ihre Eingaben stimmen nicht überein.');
      return;
    }
    const headers={
        "Authorization": "Bearer "+accessToken,
    }
    const payload={
        "newpw": newPassword,
    }
    apiRequest('POST', 'newpassword', payload, headers, newPasswordCb);
  }
  return(
    <Box p={2}>
      <Grid container >
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} sm={8} md={6}>
              <Card >
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <img src={ectoollogo} height="50" alt="ectool" loading="lazy"/>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5">{t("Neues Passwort")}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">{t("Bitte vergeben Sie ein neues Passwort für Ihren Account.")}</Typography>
                    </Grid>
                  </Grid>
                  <form>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField 
                          type={showPassword ? "text":"password"}
                          fullWidth
                          error={newPasswordError}
                          helperText={newPasswordError}
                          label={t("Neues Passwort")}
                          variant="outlined"
                          id="newpassword"
                          placeholder="Passwort eingeben ..."
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          InputProps={{
                            endAdornment: 
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  tabIndex={-1}
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField 
                          type={showPassword ? "text":"password"}
                          fullWidth
                          error={confirmPasswordError}
                          helperText={confirmPasswordError}
                          label={t("Passwort bestätigen")}
                          variant="outlined"
                          id="confirmpassword"
                          placeholder="Passwort eingeben ..."
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          InputProps={{
                            endAdornment: 
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  tabIndex={-1}
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                          }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={handlePasswordChangeClick}
                          fullWidth
                        >Passwort ändern</Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}
export default NewPassword;
